import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge", "picker"]

  open(event) {
    event.preventDefault()
    this.badgeTarget.classList.add("hidden")
    this.pickerTarget.classList.remove("hidden")
    this.pickerTarget.querySelector("select").focus()
  }

  close() {
    this.pickerTarget.classList.add("hidden")
    this.badgeTarget.classList.remove("hidden")
  }

  submit() {
    this.element.querySelector("form").requestSubmit()
  }
}
